import React, { useState } from 'react';
import './style.css';

import Modal from 'component/Modal';
import { Img } from 'component/FrameL';

export default ({ Images }) => {
    const [isImageOpen, setIsImageOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);

    return <>
        <div className="w-full collage-container">
            {Images.map((Image, i) => {
                return <button key={i} className="w-full tailwind-block"
                    aria-label="Open Image"
                    onClick={() => {
                        setSelectedImageIndex(i);
                        setIsImageOpen(true);
                    }} >
                    <Img Image={Image} />
                </button>
            })}
        </div>

        <Modal
            isOpen={isImageOpen}
            onClose={() => {
                setIsImageOpen(false);
            }}>
            {Images.map((Image, i) => {
                // destructure because we don't want to pass in width + height in this case
                const { url, alternativeText, caption } = Image;
                return <div className={`m-8 relative w-fit mx-auto ${i !== selectedImageIndex ? 'hidden' : ''}`}>
                    <Img src={url} alt={alternativeText} key={i} className="max-h-screen" />
                    <p className='p-4 bg-white bg-opacity-70 w-full absolute bottom-0'>{caption}</p>
                </div>
            })}
        </Modal>
    </>;
};
